import { UiOrderStatus } from '../utils'

export const STATUS_LABEL: Record<UiOrderStatus, string> = {
  pending: 'Pending',
  in_progress: 'Preparing',
  ready: 'Ready for pickup',
  on_the_way: 'On the way',
  completed: 'Completed',
  cancelled: 'Cancelled',
}

// CSS custom property names — resolve with var() at the call site so the
// value tracks the active theme.
export const STATUS_COLOR_VAR: Record<UiOrderStatus, string> = {
  pending: '--color-info',
  in_progress: '--color-warning',
  ready: '--color-success',
  on_the_way: '--color-success',
  completed: '--color-text-weak',
  cancelled: '--color-danger',
}
